import { geniFetch } from "./geniBackend";

/** POST /account/onboarding/complete — backend returns its own authoritative timestamp. */
export async function saveOnboardingCompleted(): Promise<string> {
  const response = await geniFetch<{ onboardingCompletedAt: string }>(
    "/account/onboarding/complete",
    { method: "POST" },
  );
  return response.onboardingCompletedAt;
}
